import { useRef } from 'react'

import useFileUpload, { IS_LOADING } from '@hooks/useFileUpload'
import useSnackBarContext from '@contexts/snackBarContext'
import { colors, size } from '@styles/theme'
import useDialog from '@hooks/useDialog'
import axios from '@utils/webRequests'
import styled from '@emotion/styled'

import ImagePreparationLoading from '@elements/ImagePreparationLoading'
import VisuallyHiddenInput from '@elements/VisuallyHiddenInput'
import ImageCropperDialiog from '@forms/ImageCropperDialog'
import { ButtonBase, Portal } from '@mui/material'
import { TbPlus } from 'react-icons/tb'


const MediaUploadButton = styled(ButtonBase)`
  display: flex;
  align-items: center;
  justify-content: center;

  aspect-ratio: 1/1;
  border-radius: 100px;

  background-color: grey;
  background-color: ${colors.statusColors.right_now('primary')};
`

const getImageDimensions = (url) => new Promise((resolve, reject) => {
  // alert(file)
  const img = new Image();
  // const url = URL.createObjectURL(file);
  img.onload = () => {
    // URL.revokeObjectURL(url);
    resolve({ width: img.width, height: img.height });
  };
  img.onerror = reject;
  img.src = url;
});

const UserMediaUploadButton = ({ onUpdateSuccess, disabled, loaderRef, ...rest }) => {
  const [isImageCropperOpen, openImageCropper, closeImageCropper] = useDialog('user-media_image-croper-dialog', 'true')
  const { addSnackBar, snackError } = useSnackBarContext()
  const hiddenInput = useRef()
  const {
    file,
    handleFileUpload,
    resetFileState,
    fileUrl,
    isFileLoaded,
  } = useFileUpload()

  const handleClick = () => {
    hiddenInput.current.click()
  }

  const onImageCropperClose = () => {
    closeImageCropper()
    resetFileState()
  }

  const handleUploadWrapper = (e) => {
    e.stopPropagation()
    handleFileUpload(e)
      .then((res) => getImageDimensions(res))
      .then(({ height, width }) => openImageCropper(null, { state: { aspect: width/height } }))
      .catch((err) => {
        let error = err
        if (Error.isError(error)) error = err.toString()
        snackError({ error, fallbackMessage: 'Browser could not process image. Please try another.' })
      })
  }

  const uploadSelectedImages = (croppedFile) => {
    const formData = new FormData()
    formData.append('files[]', croppedFile)

    return axios.post(`api/my/images/cached_images`, formData)
      .then((res) => {
        console.log(res.data)
        if (typeof onUpdateSuccess === 'function') onUpdateSuccess(res.data)
        addSnackBar({ message: 'Image uploaded successfully.' })
        onImageCropperClose()
      })
      .catch((error) => {
        snackError({ fallbackMessage: 'Image Upload Failed', error, })
        onImageCropperClose()
      })
  }

  return (
    <>
      <Portal container={() => loaderRef.current}>
        {isFileLoaded === IS_LOADING && <ImagePreparationLoading />}
      </Portal>
      <ImageCropperDialiog
        isOpen={isImageCropperOpen}
        setClosed={onImageCropperClose}
        fileUrl={fileUrl}
        uploadImage={uploadSelectedImages}
        headerText='Crop Image'
      />
      <MediaUploadButton
        disabled={disabled}
        onClick={handleClick}
        {...rest}>
        <VisuallyHiddenInput
          disabled={disabled}
          ref={hiddenInput}
          type='file'
          accept='image/*'
          onChange={handleUploadWrapper}
        />
        <TbPlus size={size(5)} />
      </MediaUploadButton>
    </>
  )
}

export { UserMediaUploadButton }
